import { PAGE_SIZE } from '../../utils/environment'

export const appendPageNumber = (url, page = 0) => {
	return `${url}&${PAGE_SIZE}`
}
